import React from 'react'
import { Link } from 'react-router-dom'
import './index.css'
interface IconLinkProps {
    imgSrc?: string
    to: string
    title?: string
    className?: string
}
const IconLink: React.FC<IconLinkProps> = (props) => {
    const { imgSrc, to, title, className } = props
    return (
        <Link className={`icon-link ${className}`} to={to}>
            <img className='icon' src={imgSrc} alt='icon' />
            {title && <p className='text'>{title}</p>}
        </Link>
    )
}

export default IconLink
